"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eUserZones = void 0;
const user_class_1 = __importDefault(require("./user.class"));
var eUserZones;
(function (eUserZones) {
    eUserZones["USA_NORTH_EAST"] = "USA - Northeast";
    eUserZones["USA_SOUTH_EAST"] = "USA - Southeast";
    eUserZones["USA_WEST"] = "USA - West";
    eUserZones["USA_MID_ATLANTIC"] = "USA - Mid Atlantic";
    eUserZones["USA_MID_WEST"] = "USA - Midwest";
    eUserZones["USA_NYC_LONG_ISLAND"] = "USA - NYC/Long Island";
    eUserZones["USA_SOUTH_WEST"] = "USA - Southwest";
    eUserZones["CANADA"] = "Canada";
    eUserZones["UNITED_KINGDOM"] = "United Kingdom";
    eUserZones["EUROPE"] = "Europe";
    eUserZones["FAR_EAST_ASIA_AUSTRALIA"] = "Far East, Asia & Australia";
})(eUserZones = exports.eUserZones || (exports.eUserZones = {}));
exports.default = user_class_1.default;
//# sourceMappingURL=index.js.map